
  <div class="container">
    <header class="mainarea w-container">
      <a href="https://ihsmarkit.com/index.html" title="IHS Markit" target="_blank" rel="noopener" i18n-title>
        <img src="{{logoLink}}" width="330" height="36" alt="" class="logo" />
      </a>
    </header>

    <router-outlet></router-outlet>
    <!-- Begin Footer File -->
   <footer class="footer_container" style="margin-left: -15px; margin-right: -15px;">        
        <span style="font-size: 12px;"><a i18n i18n-href i18n-title href="/#/privacy-notice" target="_blank" [ngStyle]="{'display':hideNativeLanguagePrivacyNitice}" class="footerlink">Privacy Notice</a></span>
        <span style="font-size: 12px;"><a href={{apacenprivacynotice}} target="_blank" [ngStyle]="{'display':disableENPrivacy}" class="footerlink">Privacy Notice</a></span>       
        <span style="margin-left: 12px; color: #fff; font-size: 12px;" i18n>Copyright © 2023 IHS Markit. All Rights Reserved</span>
      </footer>
</div>
